import React, { useContext } from 'react';
import classNames from 'classnames';
import { isEmpty } from 'lodash';
import { I18nProvider } from '@fiverr-private/fiverr_context';
import ScTilesCarousel from '../common/sc_tiles_carousel';
import TopFiltersCarousel from '../common/top_filters_carousel';
import { DOMINATE_SC_FOR_SEARCH } from '../../abTestAllocations/navigationTilesSearch/constants';
import { MINIMUN_TILES_LENGTH } from '../common/tiles_carousel/constants';
import { getScTilesData } from '../common/sc_tiles_carousel/utils';
import { getFilterTilesCarousel } from '../common/top_filters_carousel/utils';
import { SearchPropTypes } from '../../types/index';
import { AppContext } from '../context/listingsContext';
import { DesktopTopBar, TouchTopBar } from '../common/top_bar';
import { BusinessEmptyResults } from '../common';
import BusinessListings from '../common/listings/BusinessListings';
import SearchResultsCounter from './search_results_counter';
import RelatedSearch from './related_search';
import SearchHeader from './search_header';

const BusinessSearch = (props) => {

    const {
        displayData,
        appFilters,
        pagination
    } = props;

    const { isTouch,
        listings: [listings],
        isDefaultLocale,
        inSearchNavigationTiles,
        dominateSubCategoryId,
        significantLeafCategories = []
    } = useContext(AppContext);

    const { subCategory, active } = appFilters;
    const allGigs = [ ...listings.gigs, ...listings.restOfGigs ];
    const hasGigs = allGigs.length > 0;
    const isEmptySearch = isEmpty(active) && !hasGigs;
    const subCatFiltersCarousel = getFilterTilesCarousel(dominateSubCategoryId);
    const scTilesData = getScTilesData(significantLeafCategories, subCategory);
    const shouldShowFiltersCarousel = inSearchNavigationTiles && DOMINATE_SC_FOR_SEARCH.includes(dominateSubCategoryId);
    const shouldShowScCarousel = !shouldShowFiltersCarousel && inSearchNavigationTiles && scTilesData.length >= MINIMUN_TILES_LENGTH;

    return (
        <div className={classNames('search-page', { 'top-filters': !isTouch })}>
            { (isDefaultLocale && !isEmptySearch) && <RelatedSearch displayData={displayData}/>}
            { hasGigs &&
                <>
                    {isTouch ?
                        <I18nProvider>
                            {({ i18n }) => (
                                <SearchResultsCounter paginationData={pagination} displayData={displayData} i18n={i18n}/>
                            )}
                        </I18nProvider> :
                        <div className="row header-wrapper">
                            <SearchHeader subCategoryData={subCategory} searchData={displayData.searchComponentData}/>
                        </div>
                    }
                    {
                        shouldShowFiltersCarousel &&
                        <div className="row">
                            <TopFiltersCarousel topFiltersCarousel={subCatFiltersCarousel} subCategoryId={dominateSubCategoryId}/>
                        </div>
                    }
                    {
                        shouldShowScCarousel &&
                        <div className="row">
                            <ScTilesCarousel scTilesData={scTilesData}/>
                        </div>
                    }
                    {isTouch ?
                        <TouchTopBar gigs={allGigs}/> :
                        <DesktopTopBar gigs={allGigs} fromSearchFlow/>
                    }
                </>
            }
            { isEmptySearch ? <BusinessEmptyResults/> : <BusinessListings/> }

        </div>
    );
};

BusinessSearch.propTypes = SearchPropTypes;

export default BusinessSearch;
